module.exports = __webpack_public_path__ + "img/sale3.d1719e37.png";